export default __webpack_public_path__ + "static/media/arrow-blue.8c2cdbe8.svg";